import { render, staticRenderFns } from "./blankPropsDialog.vue?vue&type=template&id=f2a53fa4&scoped=true&"
import script from "./blankPropsDialog.vue?vue&type=script&lang=js&"
export * from "./blankPropsDialog.vue?vue&type=script&lang=js&"
import style0 from "./blankPropsDialog.vue?vue&type=style&index=0&id=f2a53fa4&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2a53fa4",
  null
  
)

export default component.exports